import React, { useState } from 'react';
// Reusable Alert component
const Alert = ({ type, message }: { type: 'error' | 'success', message: string }) => (
  <div className={`w-full flex items-center px-4 py-3 rounded-xl mb-4 font-semibold text-sm shadow-sm border 
    ${type === 'error' ? 'bg-red-50 text-red-800 border-red-200' : 'bg-green-50 text-green-800 border-green-200'}`}
    role="alert">
    {type === 'error' ? (
      <svg className="h-5 w-5 mr-2 text-red-500" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
    ) : (
      <svg className="h-5 w-5 mr-2 text-green-500" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" /></svg>
    )}
    <span>{message}</span>
  </div>
);
import sunshineLogo from './assets/sunshine-logo.jpg';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from './firebase';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;
      // Store user info in localStorage
      localStorage.setItem('gympro_user', JSON.stringify({
        email: user.email,
        uid: user.uid,
        displayName: user.displayName || '',
      }));
      setSuccess('Login successful! Redirecting...');
      setTimeout(() => {
        window.location.href = '/dashboard';
      }, 1200);
    } catch (err: any) {
      setError(err.message || 'Login failed.');
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center px-4">
      <div className="bg-white rounded-2xl shadow-md border border-gray-100 p-8 w-full max-w-md flex flex-col items-center">
        <img src={sunshineLogo} alt="Sunshine Gym Logo" className="h-16 w-16 object-contain mb-4" />
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Admin Login</h1>
        <p className="text-gray-600 font-medium mb-6 text-center">Sign in to manage your gym dashboard</p>
        <form className="w-full" onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-sm font-bold text-gray-700 mb-2">Email</label>
            <input
              type="email"
              className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-gray-900 placeholder-gray-500 focus:ring-2 focus:ring-gray-900 focus:border-gray-900 transition-all duration-200 font-semibold"
              placeholder="admin@sunshinegym.in"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="mb-6">
            <label className="block text-sm font-bold text-gray-700 mb-2">Password</label>
            <input
              type="password"
              className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-gray-900 placeholder-gray-500 focus:ring-2 focus:ring-gray-900 focus:border-gray-900 transition-all duration-200 font-semibold"
              placeholder="Enter password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
            />
          </div>
          {error && <Alert type="error" message={error} />}
          {success && <Alert type="success" message={success} />}
          <button
            type="submit"
            className="w-full bg-gray-900 text-white px-8 py-3 rounded-xl font-semibold transition-all duration-200 hover:bg-gray-800 hover:shadow-lg"
          >
            Login
          </button>
        </form>
      </div>
      <a href="/" className="mt-8 text-gray-500 hover:text-gray-900 font-medium transition-colors duration-200">&larr; Back to Home</a>
    </div>
  );
};

export default LoginPage;
